// extracted by mini-css-extract-plugin
module.exports = {"carousel":"special-projects_carousel__Gso2w","carousel__content":"special-projects_carousel__content__YXPD0","item":"special-projects_item__Kssy2"};